import React from 'react';
import { useTranslation } from 'react-i18next';

import { NotificationsModalListComponent } from './NotificationsModalList.component';
import BaseModalComponent, { BaseModalProps } from '../BaseModal.component';

interface Props extends BaseModalProps  {
  targetType?: string;
  targetId?: number | string;
  personId?: number | string;
  isAccessDelete?: boolean;
  isAccessReadAll?: boolean;
}

/**
 * Task for improvements: https://jira.intexsoft.com/browse/ITXHUNTER-1087
 */
const NotificationsModalComponent = (restProps: Props) => {
  const { t } = useTranslation();

  return (
    <BaseModalComponent header={t('Notifications')}>
      <NotificationsModalListComponent {...restProps} />
    </BaseModalComponent>

  );
};

export default NotificationsModalComponent;
